import React from 'react';

import styles from './Loader.module.scss';

const Loader = ({ text = 'Загрузка данных', type = 'blackType' }) => {
  const typeBgClass =
    type === 'whiteType' ? styles.whiteTypeBg : styles.blackTypeBg;
  const typeColorClass =
    type === 'whiteType' ? styles.whiteTypeColor : styles.blackTypeColor;

  return (
    <div className={styles.LoadingBlock}>
      <div className={styles.LoadingPoints}>
        <div className={typeBgClass} />
        <div className={typeBgClass} />
        <div className={typeBgClass} />
        <div className={typeBgClass} />
      </div>
      <p className={`${styles.LoadingText} ${typeColorClass}`}>{text}</p>
    </div>
  );
};

export default Loader;
